// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateFaq from './routes/faq';
import templateForm from './routes/form';
import taxCategoryProdotti from './routes/modal-trigger';
import templateArchivioMarchi from './routes/modal-trigger';
import templateGamingLavoraConNoi from './routes/gaming';
import templateSurvey from './routes/survey';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Template FAQ
  templateFaq,
  // Template Form
  templateForm,
  // Tassionomia Prodotti
  taxCategoryProdotti,
  // Archivio Marchi
  templateArchivioMarchi,
  // Template Gaming
  templateGamingLavoraConNoi,
  // Template Survey
  templateSurvey,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js